
<div class="video">

	<iframe
		[src]="url | safe: 'url'"
		width="600"
		height="337"
		frameborder="0"
		webkitallowfullscreen
		mozallowfullscreen
		allowfullscreen
	></iframe>


</div>


